// Traditional research time estimates per activity type
export const TRADITIONAL_HOURS: Record<string, number> = {
  pre_read: 8,           // Typical qualitative analysis: 8 hours
  validation: 40,        // Recruitment + moderation + analysis: 40 hours
  report: 4,             // Report generation and formatting: 4 hours
  churn_analysis: 16,    // Join datasets, analyze, triangulate: 16 hours
  segment_echo: 6,       // Segment analysis and synthesis: 6 hours
}

// Hourly rate for research operations ($150/hr default)
export const DEFAULT_HOURLY_RATE_CENTS = 15000

export interface TimeSavingsEvent {
  activity_type: string
  echo_minutes_actual: number
}

export function computeHoursSaved(event: TimeSavingsEvent): number {
  const traditional = TRADITIONAL_HOURS[event.activity_type] ?? 4
  const echoHours = event.echo_minutes_actual / 60
  return Math.max(0, traditional - echoHours)
}

export function computeCostSavingsCents(hoursSaved: number, hourlyRateCents = DEFAULT_HOURLY_RATE_CENTS): number {
  return Math.round(hoursSaved * hourlyRateCents)
}

export interface AnalyticsSummary {
  total_pre_reads: number
  total_validations: number
  total_hours_saved: number
  total_cost_savings_cents: number
  accuracy_rate: number | null
  active_workspaces: number
  active_clients: number
  pre_reads_per_day: number
}

export function buildROIStatement(summary: AnalyticsSummary): string {
  const costSavings = (summary.total_cost_savings_cents / 100).toFixed(0)
  const avgPerPreRead = summary.total_pre_reads > 0
    ? Math.round(summary.total_hours_saved / summary.total_pre_reads * 10) / 10
    : 0
  return `Echosome has saved your team ${Math.round(summary.total_hours_saved)} hours ($${costSavings}) across ${summary.total_pre_reads} pre-reads — an average of ${avgPerPreRead}h per run.`
}
